skrilla.controller('actionLoLContestsModalCtrl', function ($scope, searchService, cacheService, modalService) {
    $scope.contests = cacheService.getObject("selectedLoLContests");

    function resetContests(){
        $scope.contests.forEach(function(contest){
            contest.updating = false;
            contest.updated = false;
            contest.failed = false;
        });
    }
    resetContests();

    $scope.cancel = function(){
        var contests = $scope.contests.filter(function(contest){return contest.contestState !== "CANCELLED" && contest.contestState !== "COMPLETED";});
        if(contests.length === 0){alert("No contests are able to be cancelled!")}
        else {
            modalService.confirm("Are you sure you'd like to cancel " + contests.length + " contests?", function() {
                resetContests();
                cancelContests(contests, 0);
            });
        }
    }

    function cancelContests(contests, index){
        contest = contests[index];
        contest.updating = true;
        searchService.put('lol/contests/daily/' + contest.id + '/cancel').then(function(response){
                contest.contestState = "CANCELLED";
                contest.updating = false;
                contest.updated = true;
                if(index === contests.length -1){
                    swal("Success!", "All " + contests.length + " Contests were cancelled!", "success");
                }else{
                    cancelContests(contests, index + 1);
                }
            },
            function(response){
                contest.updating = false;
                contest.failed = true;
            });
    }


    $scope.getBackground = function(contest){
        return contest.updating === true? "#fff7e6" : contest.updated === true ? "#c2ffb5" : contest.failed === true ? "#ff5656" : "";
    }

    $scope.publish = function(){
        var contests = $scope.contests.filter(function(contest){return contest.publicationState === "PENDING";});
        if(contests.length === 0){alert("No contests are able to be published!")}
        else {
            modalService.confirm("Are you sure you'd like to publish " + contests.length + " contests?", function() {
                resetContests();
                publishContests(contests, 0);
            });
        }
    }

    function publishContests(contests, index){
        contest = contests[index];
        contest.updating = true;
        searchService.post('lol/contests/daily/' + contest.id + '/publish').then(function(response){
                contest.updating = false;
                contest.updated = true;
                contest.publicationState = "PUBLISHED";
                if(index === contests.length -1){
                    swal("Success!", "All " + contests.length + " Contests were published!", "success");
                }else{
                    publishContests(contests, index + 1);
                }
            },
            function(response){
                contest.updating = false;
                contest.failed = true;
            });
    }

});